// extracted by mini-css-extract-plugin
export default {"cls1":"Stats-cls1_etH","cls2":"Stats-cls2_mQT Stats-cls1_etH"};